import { animateScroll } from "react-scroll"
import { useScrollPosition } from "../../hooks/useScrollPosition"
const ScrollUpButton = () => {
	const scrollPosition = useScrollPosition()
	const scroll = () => {
		animateScroll.scrollToTop({ duration: 500 });
	}

	return (
		<span className={`${scrollPosition < 500 && 'hidden'} fixed bottom-5 right-5`}>

			<button onClick={scroll} className='h-10 w-10 text-white p-1  px-3 focus:outline-none focus-visible:ring ring-slate-300 rounded-full bg-primary '>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-full h-full">
					<path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18" />
				</svg>
			</button>
		</span>
	)
}

export default ScrollUpButton